import { render } from "./NavInit.vue?vue&type=template&id=06ef3dea"
import script from "./NavInit.vue?vue&type=script&lang=js"
export * from "./NavInit.vue?vue&type=script&lang=js"

import "./NavInit.vue?vue&type=style&index=0&id=06ef3dea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__